import { getIntegrationStatusStyle } from "@/utils/integration-status";
import { cn } from "@/lib/utils";

interface IntegrationStatusBadgeProps {
  status?: string | null;
  className?: string;
}

export function IntegrationStatusBadge({
  status,
  className,
}: IntegrationStatusBadgeProps) {
  const { label, badge, dot } = getIntegrationStatusStyle(status);

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold whitespace-nowrap",
        badge,
        className
      )}
    >
      <span className={cn("h-2 w-2 shrink-0 rounded-full", dot)} />
      {label}
    </span>
  );
}
